<template>
  <div>
    <b-row class="justify-content-end">
      <b-col md="3">
        <!-- <b-button
          v-b-modal.client-modal
          variant="primary"
          class="button-mt "
        >
          <feather-icon icon="ZapIcon" />
          {{ $t('generals.add')}}
        </b-button>
        <b-button
          v-b-modal.add-new-client
          variant="success"
          class="button-mt ml-2"
        >
          <feather-icon icon="TrelloIcon" />
          Добавить
        </b-button> -->
      </b-col>

      <b-col md="3">
        <b-form-group v-if="isAdmin" :label="$t('clients.manager') + ':'">
          <LazySelect
            v-model="filter.manager"
            :options="getUsers"
            :get-option-label="(user) => user.first_name"
            :fetch="FETCH_USERS_LIST"
            :reduce="(user) => user.id"
            class="bg-white"
            @input="refresh"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group :label="$t('clients.created_from') + ':'">
          <flat-pickr
            v-model="filter.start_date"
            class="form-control bg-white"
            style="max-width: 250px;"
            :config="configdateTimePicker"
            @on-change="refresh"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group :label="$t('clients.date_of_creation') + ':'">
          <flat-pickr
            v-model="filter.end_date"
            class="form-control bg-white"
            style="max-width: 250px;"
            :config="configdateTimePicker"
            @on-change="refresh"
          />
        </b-form-group>
      </b-col>
      <b-col md="2">
        <b-form-group :label="$t('clients.gender') + ':'">
          <v-select
            v-model="filter.gender"
            :options="genderOptions"
            class="bg-white"
            :reduce="(gender) => gender.id"
            :get-option-label="(option) => option.title[$i18n.locale]"
            @input="refresh"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <b-form-group :label="$t('clients.type_of_ownership') + ':'">
          <v-select
            v-model="filter.entity"
            :options="entityOptions"
            class="bg-white"
            :reduce="(entity) => entity.id"
            label="title"
            @input="refresh"
          />
        </b-form-group>
      </b-col>
      <b-col md="3">
        <AppSearchInput
          :label="$t('generals.search')"
          :placeholder="$t('generals.search')"
          @callback="search"
        />
      </b-col>
    </b-row>

    <b-table
      id="client-table"
      ref="clientTable"
      :items="items"
      :fields="fields"
      :tbody-tr-class="['tableRowClass']"
      show-empty
      small
      select-mode="single"
      selectable
      :current-page="currentPage"
      @row-selected="onRowSelected"
    >
      <template #head()="data">
        <span>{{ $t(data.label) }}</span>
      </template>
      <template #empty>
        <div class="text-center">
          {{ $t("general.no_records_to_show") }}
        </div>
      </template>

      <!--  :filter-included-fields="filterOn"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered" -->

      <!-- @row-selected="onRowSelected" -->

      <!--
      <template #head()="data">
          <span>{{  $t(`${data.label}`) }}</span>
      </template> -->

      <template #cell(title)="row">
        <div class="pt-50 d-flex justify-content-start align-items-center">
          <span>
            <feather-icon icon="PocketIcon" size="25" />
          </span>
          <div class="tableTitle text-left pl-2 text-dark">
            <small
              v-if="row.item.entity == 'yuridiskiy'"
              class="text-muted text-lowercase"
              >{{ $t("clients.entity") }}</small
            >
            <h5>{{ row.value }}</h5>
            <p v-if="row.item.sphere_of_activity">
              <small class="text-muted">
                {{ row.item.sphere_of_activity.title.ru }}
              </small>
            </p>
          </div>
        </div>
      </template>

      <template #cell(manager)="row">
        <b-avatar
          v-if="row.item.manager"
          size="lg"
          variant="primary"
          :src="row.item.manager.photo"
        />
        <p v-if="row.item.manager" class="mb-0 text-dark">
          {{ row.item.manager.first_name }}
        </p>
      </template>

      <template #cell(gender)="{ item }">
        <template v-if="item.gender === 'man'">
          {{ $t("clients.man") }}
        </template>
        <template v-else-if="item.gender === 'woman'">
          {{ $t("clients.woman") }}
        </template>
      </template>
      <!-- <template #cell(status)="row">
        <b-badge
          v-if="row.item.status_of_client"
          :variant="row.item.status_of_client.color"
        >
          {{ row.item.status_of_client.title.ru }}
        </b-badge>
      </template> -->

      <template #cell(inn)="row">
        <div class="d-flex text-dark">
          {{ innParsing(row.value) }}
        </div>
      </template>

      <template #cell(contact)="row">
        <div>
          <div class="d-flex align-items-center">
            <feather-icon icon="PhoneIcon" class="mr-50 text-black" size="18" />
            <span v-if="row.item.phones" class="fs-14px text-black text-dark">{{
              row.item.phones[0]
            }}</span>
            <span v-else class="fs-14px text-muted">{{
              $t("clients.no_information")
            }}</span>
          </div>

          <div class="d-flex align-items-center">
            <feather-icon icon="MailIcon" class="mr-50 text-black" size="18" />
            <span
              v-if="row.item.emails && row.item.emails.length"
              class="fs-14px text-black text-dark"
              >{{ row.item.emails[0] }}</span
            >
            <span v-else class="fs-14px text-muted">{{
              $t("clients.no_information")
            }}</span>
          </div>
        </div>
      </template>

      <template #cell(agent)="row">
        <div v-for="employee in row.item.employee" :key="employee.id">
          <div class="d-flex align-items-center">
            <feather-icon icon="UserIcon" class="mr-50 text-black" size="18" />
            <span
              v-if="row.item.employee"
              class="fs-14px text-black text-dark"
              >{{ employee.name }}</span
            >
            <span v-else class="fs-14px text-muted">{{
              $t("clients.no_information")
            }}</span>
          </div>
          <div v-if="employee.phones">
            <div
              v-for="(phone, index) in employee.phones"
              :key="index"
              class="d-flex align-items-center"
            >
              <feather-icon
                icon="PhoneIcon"
                class="mr-50 text-black"
                size="18"
              />
              <span v-if="phone" class="fs-14px text-black text-dark">{{
                phone
              }}</span>
              <span v-else class="fs-14px text-muted">{{
                $t("clients.no_information")
              }}</span>
            </div>
          </div>

          <div v-else class="d-flex align-items-center">
            <feather-icon icon="PhoneIcon" class="mr-50 text-black" size="18" />
            <span class="fs-14px text-muted">{{
              $t("clients.no_information")
            }}</span>
          </div>
        </div>
      </template>

      <template
        v-if="GET_USER_PERMISSIONS.includes('sales_management')"
        #cell(actions)
      >
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          v-b-modal.lid-modal
          variant="warning"
          size="md"
          class="p-75"
        >
          <feather-icon icon="PlusIcon" class="mr-25" size="15" />
          {{ $t("clients.lead") }}
        </b-button>
      </template>

      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">
              {{ key }}: {{ value }}
            </li>
          </ul>
        </b-card>
      </template>
    </b-table>
    <!-- pagination -->
    <!-- style="border-top: 1px solid lightgrey;" -->
    <div
      class="d-flex justify-content-between align-items-center flex-wrap mb-75 shadow rounded bg-white p-1"
    >
      <div class="d-flex align-items-center mb-0">
        <span class="text-nowrap text-black ml-1">
          {{ $t("generals.show_from") }}
        </span>
        <b-form-select
          v-model="perPage"
          :options="['5', '10', '15']"
          class="mx-1 text-black"
          @change="changePerPage"
        />
        <!-- <span class="text-nowrap text-black"> {{$t('pagination.entries')}} </span> -->
      </div>
      <div class="mb-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          first-number
          last-number
          align="right"
          prev-class="prev-item"
          next-class="next-item"
          class="mt-1 mb-0"
          @change="changePage"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </div>
    </div>

    <addNewClient :statusesclient="statusesclient" />
    <ClientModal :statusesclient="statusesclient" @refresh="refresh" />
    <add-new-lid-modal />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import {
  BFormGroup,
  BRow,
  BCol,
  BCard,
  BButton,
  BTable,
  // BBadge,
  BPagination,
  BFormSelect,
  BAvatar,
  VBTooltip,
  VBToggle,
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
// eslint-disable-next-line import/no-extraneous-dependencies
import { Russian } from "flatpickr/dist/l10n/ru";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import AppSearchInput from "./components/AppSearchInput.vue";
import addNewClient from "./components/AddNewClient.vue";
import ClientModal from "./components/ClientModal.vue";
import addNewLidModal from "../Kanban/components/LidModal.vue";
import { getUserData } from "@/auth/utils";
import LazySelect from "@/components/LazySelect.vue";

export default {
  components: {
    BButton,
    FeatherIcon,
    BPagination,
    BFormSelect,
    BFormGroup,
    BRow,
    BCol,
    VSelect,
    BCard,
    BTable,
    // BBadge,
    BAvatar,
    AppSearchInput,
    addNewClient,
    flatPickr,
    ClientModal,
    addNewLidModal,
    LazySelect,
  },
  directives: {
    Ripple,
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
  },
  props: {
    update: {
      type: String,
      required: false,
      default: "",
    },
    query: {
      type: Object,
      required: false,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      items: [],
      filter: {
        search: "",
        status_of_client: null,
        manager: null,
        entity: null,
        start_date: "",
        end_date: "",
      },
      entityOptions: [
        {
          title: this.$t("clients.entity"),
          id: "yuridiskiy",
        },
        {
          title: this.$t("clients.natural_person"),
          id: "fizichiskiy",
        },
      ],
      genderOptions: [
        {
          title: {
            uz: "Erkak",
            ru: "Мужской",
            en: "Male",
          },
          id: "man",
        },
        {
          title: {
            uz: "Ayol",
            ru: "Женский",
            en: "Female",
          },
          id: "woman",
        },
      ],
      totalRows: 0,
      currentPage: 1,
      perPage: 10,
      fields: [
        {
          label: "ID",
          key: "id",
          thClass: "tableHeadClass text-center",
        },
        {
          label: "clients.client_name",
          key: "title",
          thClass: "tableHeadClass",
        },

        {
          label: "clients.manager",
          key: "manager",
          thClass: "tableHeadClass pl-0 text-center",
        },
        {
          label: "clients.gender",
          key: "gender",
          thClass: "tableHeadClass pl-2",
          tdClass: "text-left",
        },
        // {
        //   label: 'ИНН',
        //   key: 'inn',
        //   thClass: 'tableHeadClass',
        // },
        {
          label: "clients.contacts",
          key: "contact",
          thClass: "tableHeadClass pl-3",
        },
        {
          label: "clients.buyers",
          key: "agent",
          thClass: "tableHeadClass",
        },
        {
          label: "clients.actions",
          key: "actions",
          thClass: "tableHeadClass text-center",
        },
      ],
      configdateTimePicker: {
        altInput: true,
        altFormat: "d.m.Y",
        dateFormat: "Y-m-d",
        locale: Russian,
      },
      delay: 200,
    };
  },
  computed: {
    ...mapGetters("clients", [
      "getClientsList",
      "getStatusClient",
      "getUsers",
      "GET_CLIENT_GROUPS",
    ]),
    ...mapGetters("users", ["GET_USER_PERMISSIONS"]),
    isAdmin() {
      const user = getUserData();
      return user.is_superuser || false;
    },
    statusesclient() {
      return this.getStatusClient.map((status) => ({
        id: status.id,
        title: status.title.ru,
      }));
    },
  },

  mounted() {
    this.refresh();
    this.GET_STATUS_CLIENT();
    this.FETCH_USERS_LIST({ is_employee: true });
    this.FETCH_CLIENT_GROUPS();
  },

  methods: {
    ...mapActions("clients", [
      "FETCH_CLIENTS_LIST",
      "GET_STATUS_CLIENT",
      "FETCH_USERS_LIST",
      "FETCH_CLIENT_GROUPS",
    ]),
    innParsing(inn) {
      return `${inn.slice(0, 3)} ${inn.slice(3, 6)} ${inn.slice(6, 9)}`;
    },

    search(text) {
      this.filter.search = text;
      this.refresh();
    },

    onRowSelected(data) {
      this.$router.push(`/clients/${data[0].id}`);
    },

    async refresh() {
      this.filter.page = this.currentPage;
      this.filter.page_size = this.perPage;
      clearTimeout(this.delay);
      this.delay = setTimeout(async () => {
        await this.FETCH_CLIENTS_LIST(this.filter);
        this.items = this.getClientsList.results;
        this.totalRows = this.getClientsList.count;
      }, 200);
    },
    changePage(value) {
      this.currentPage = value;
      this.refresh({
        page: value,
        page_size: this.perPage,
      });
    },
    changePerPage() {
      this.refresh({
        page: this.currentPage,
        page_size: this.perPage,
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

#client-table {
  border-collapse: separate;
  border-spacing: 0 1rem;
}
.tableRowClass {
  background: white;
  transform: translateY(5px);
  transition: all 0.5s ease-in-out;
  text-align: center;
  box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
  // -webkit-box-shadow:  0 4px 20px 0px lightgrey;  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
  // -moz-box-shadow:     0 4px 20px 0px lightgrey;  /* Firefox 3.5 - 3.6 */
  // box-shadow:          0 4px 6px 0px lightgrey;
  td {
    border-top: 0;
    padding: 20px !important;
    &:first-child {
      // padding-left: 25px !important;
      border-top-left-radius: 0.5rem;
      border-bottom-left-radius: 0.5rem;
    }

    &:last-child {
      border-top-right-radius: 0.5rem;
      border-bottom-right-radius: 0.5rem;
    }
  }
}

.tableRowClass:hover {
  transform: translateY(0);
  // -webkit-box-shadow:  0 4px 20px 0px lightgrey;  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
  // -moz-box-shadow:     0 4px 20px 0px lightgrey;  /* Firefox 3.5 - 3.6 */
  // box-shadow:          0 4px 6px 0px lightgrey;
}

.tableHeadClass {
  background: none !important;
  border: none !important;
  // text-align: center;
  // padding-left: 25px !important;
}
.tableRowClass:hover {
  .tableTitle {
    color: #7367f0 !important;
  }
}

.button-mt {
  margin-top: 25px;
}
</style>
